import { computedFrom } from 'aurelia-binding';
import { autoinject, PLATFORM } from 'aurelia-framework';
import { Authentication } from '~/authentication/authentication';
import {
	SimpleDialog,
	SimpleDialogModel,
} from '~/components/dialog/simple-dialog';

export enum ContentType {
	PLAIN_TEXT = 'text/plain',
	HTML = 'text/html',
	XML = 'text/xml',
	PDF = 'application/pdf',
	PCL = 'application/vnd.hp-PCL',
	OCTET_STREAM = 'application/octet-stream',
	ACURITY_PRESENTER = 'application/vnd.finsyn-AcurityPresent', // I make up this value
}

export interface EmbedContentDialogModel extends SimpleDialogModel {
	contentType: ContentType;
	contentSrc: string;
}
@autoinject
export class EmbedContentDialog extends SimpleDialog<EmbedContentDialogModel> {
	constructor(private readonly authentication: Authentication, ...rest) {
		super(...rest);
		PLATFORM.moduleName('./embed-content-dialog');
	}

	@computedFrom('model')
	get hasContent(): boolean {
		if (this.model && this.model.contentType && this.model.contentSrc) {
			return true;
		}
		return false;
	}
}
